import Flex from '@Components/Bases/Flex';
import FormSelect from '@Components/Form/FormSelect';
import { disabledFormSelectStyles } from '@Components/Form/styles';
import { InputLabel, MenuItem } from '@mui/material';
import {
  ICarbonDetailFormValues,
  IGreenhouseFormValues,
} from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider/types';
import { CompleteSectionFormValues } from '@Utils/Types/FormValuesTypes';
import { Control, useFormContext, useWatch } from 'react-hook-form';
import { useGreenhouseGoalTerm } from '../../GreenhouseGoalTermProvider/GreenhouseGoalTermProvider';
type ScopeProps = {
  control: Control<IGreenhouseFormValues, unknown>;
  mode: 'create' | 'edit';
};
const Scope = ({ control, mode }: ScopeProps) => {
  const { ghGasScope } = useGreenhouseGoalTerm();
  const [carbonDetails, completedSection] = useWatch({
    name: [
      'greenhouseGoalTerm.carbon.details',
      'greenhouseGoalTerm.completedSection',
    ],
    control,
  }) as [ICarbonDetailFormValues[] | undefined, CompleteSectionFormValues];

  const { isCompletedTh, isCompletedEn } = completedSection || {};

  const { watch } = useFormContext();
  const currentScopeId = watch('scopeId');

  const prevScopeIds = carbonDetails?.map((detail) => detail.scopeId);
  const filterScopeOptions = ghGasScope?.filter((option) => {
    if (mode === 'edit' && option.id === currentScopeId) {
      return true;
    }
    return !prevScopeIds?.includes(option.id);
  });

  return (
    <Flex alignItems={'baseline'} gap={2} mt={1}>
      <InputLabel required sx={{ textAlign: 'end', minWidth: '350px' }}>
        ขอบเขตการปล่อยก๊าซเรือนกระจก
      </InputLabel>
      <FormSelect
        name="scopeId"
        placeholder="โปรดเลือก"
        fullWidth
        sx={
          isCompletedTh || isCompletedEn ? disabledFormSelectStyles : undefined
        }
      >
        {filterScopeOptions?.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.nameTh}
          </MenuItem>
        ))}
      </FormSelect>
    </Flex>
  );
};

export default Scope;
